import React from 'react';

const  Heading1 = (props) => {

    const {
        children,
        size,
        classe,
        theme,
        opacity
    } = props

    let textSize, textBold, color

    if(size === 'big') textSize = "text-3xl md:text-4xl lg:text-5xl"
    else if(size === "medium") textSize = "text-3xl md:text-4xl lg:text-5xl"
    else textSize = "text-xl md:text-3xl lg:text-4xl"

    if(theme === 'white') color = "text-white"
    else color = "text-secondary"

    return (
        <h1 className={`
            font-semibold
            font-primary
            // ${ opacity ? opacity : "" }
            ${textSize}
            ${color}
            ${classe}
        `}>
            { children }
        </h1>
    );
}

export default Heading1;